<mat-card style="padding: 0.5in;">
  <div class="row" style="margin-bottom: 20px;">
    <div class="col-sm-6" style="text-align: left;">
      <button mat-raised-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
    <div class="col-sm-6" style="text-align: right;">
      <button mat-raised-button color="primary" (click)="printReport()">
        <mat-icon>print</mat-icon>
        Print Report
      </button>
    </div>
  </div>

  <mat-card-content>

    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="0.5in" 
          [forcePageBreak]="'.page-break-before'">

      <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <div style="position: absolute; bottom: 10px; left: 0; right: 0; text-align: center; font-size: 10pt;">
          Page {{pageNum}} of {{totalPages}}
        </div>
      </ng-template>

      <div id="snapshotPdf" class="col-sm-12 report-content">

        <div class="row">
          <div class="col-sm-2">
            <img src="../../assets/images/ORELAP.jpg" height="175" alt="Orelap Oregon Health Authority Seal" />
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-12" style="text-align:center">
                <span class="text-primary" style="font-size: 28pt">Oregon</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12"
                style="text-align:center; border-bottom: 1px; border-bottom:solid; border-bottom-color:#337ab7">
                <span class="text-primary" style="font-size: 20pt">Environmental Laboratory Accreditation Program</span>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <img class="pull-right" src="../../assets/images/nelap2.jpg" height="200" alt="Nelap Recognized" />
          </div>
        </div>

        <div class="row" style="margin-top: 25pt">
          <div class="col-sm-7">
            <span style="font-size: 12pt" class="text-primary">Department of Agriculture, Laboratory Division</span>
          </div>
          <div class="col-sm-5">
            <span style="font-size: 12pt" class="text-primary pull-right">Oregon State Public Health Laboratory</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-7">
            <span style="font-size:12pt" class="text-primary">Department of Environmental Quality, Laboratory
              Program</span>
          </div>
          <div class="col-sm-5">
            <span style="font-size:12pt" class="text-primary pull-right">7202 NE Evergreen Pkwy, Suite 100</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-7">
            <span style="font-size:12pt" class="text-primary">Oregon Health Authority, Public Health Division</span>
          </div>
          <div class="col-sm-5">
            <span style="font-size:12pt" class="text-primary pull-right">Hillsboro, OR 97124</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <span style="font-size:12pt" class="text-primary pull-right">(503)693-4122</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <span style="font-size:12pt" class="text-primary pull-right">TTY (503)731-4031</span>
          </div>
        </div>

        <div class="row" style="margin-top: 100pt">
          <div class="col-sm-12" style="text-align:center">
            <span style="font-size: 30px"><strong>{{inspectionData.labName | sanitizePdf}}</strong></span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span style="font-size: 24px"><strong>{{inspectionData.orelapId | sanitizePdf}}</strong></span>
          </div>
        </div>

        <div class="row" style="margin-top: 25pt">
          <div class="col-sm-12" style="text-align:center">
            <span style="font-size: 24px"><strong>{{inspectionData.assessmentType | sanitizePdf}}</strong></span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12" style="text-align:center">
            <span style="font-size: 24px">{{inspectionData.assessmentDate | sanitizePdf}}</span>
          </div>
        </div>

        <div class="row" style="margin-top: 50pt">
          <div class="col-sm-12">
            <span style="font-size: 20pt"><strong>Assessment Team</strong></span>
          </div>
        </div>

        <div style="width:100%">
          <table style="width:100%">

            <ng-container *ngFor="let inspector of inspectionData.inspectors">
              <tr>
                <td class="f16" style="border-top: none;">{{inspector.firstName | sanitizePdf}} {{inspector.lastName | sanitizePdf}}</td>
                <td class="f16" style="border-top: none;">{{inspector.email | sanitizePdf}}</td>
              </tr>
            </ng-container>

          </table>
        </div>

        <div class="row page-break-before"></div>
        <div class="col-sm-12">
          <p class="f18"><strong>Introduction</strong></p>
          <p class="f16">
            The Oregon Environmental Laboratory Accreditation Program (ORELAP), in accordance with the 2016, the
            NELAC Institute (TNI) Standards and Oregon Administrative Rules (OAR) Chapter 333, Division 64, must
            conduct a comprehensive on-site assessment (OSA) of each laboratory prior to granting initial
            accreditation. In addition, an on-site assessment of each accredited laboratory must be completed at
            least every 18 - 30 months. Assessments for cause may be conducted more frequently, as determined
            necessary by the accrediting authority.
          </p>
          <p class="f16">
            The on-site assessment is an integral and requisite part of the ORELAP and is one of the primary
            means of determining a laboratory's capabilities and qualifications. During the assessment, the ORELAP
            assessment team collects and evaluates information and makes observations which are used to judge the
            laboratory's conformance to the established accreditation standards.
          </p>

          <p class="f16">
            The assessment team's findings may include the following:
          </p>
          <p class="f16">
            1. Deficiencies Requiring Immediate Attention - These deficiencies are either repeat deficiencies from
            previous assessments or deficiencies judged to critically affect data quality that must be addressed
            immediately by the laboratory. The laboratory must respond to these deficiencies in its corrective action
            plan (CAP) and provide evidence that the issue has been corrected prior to the closing of the assessment
            report.
          </p>

          <p class="f16">
            2. Deficiencies to Be Addressed in the Corrective Action Plan (CAP) - These deficiencies must be
            addressed by the laboratory in its CAP, but the CAP is not required to be completed prior to the closing
            of the assessment report. If the CAP will not be completed prior to the closing of the assessment
            report, a reasonable timeframe for completion must be included.
          </p>

          <p class="f16">
            3. Recommendations - These are aimed at helping the laboratory improve, but no response is required.
          </p>

          <p class="f16">
            Cited deficiencies are listed with the reference from the TNI Standards in an italic font. The
            assessor’s finding of nonconformance to the TNI Standards follows in a blue font.
          </p>

          <p class="f16">
            The responsibility for promulgating and enforcing occupational safety and health standards rests with
            the US Department of Labor. The laboratory is also responsible for meeting all local and Federal
            hazardous waste requirements. While it is not within the scope of the assessment team to evaluate
            health and safety regulations or hazardous waste violations, the assessment team is required to report
            these to the appropriate laboratory official and forward any potential violations to the appropriate
            authority.
          </p>

          <p class="f16">
            The following areas are examples of what have been evaluated to determine the laboratory's compliance
            with the TNI Standards and the OARs:
          </p>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <ul class="f16" style="list-style-type: disc;">
                <li>Organization and management</li>
                <li>Quality system</li>
                <li>Personnel</li>
                <li>Physical facilities</li>
                <li>Equipment and reference materials</li>
                <li>Measurement traceability and calibration</li>
                <li>Test methods and standard operating procedures (SOPs)</li>
                <li>Sample handling, sample acceptance policy, and sample receipt</li>
                <li>Records</li>
                <li>Laboratory report format and contents</li>
                <li>Subcontracting of samples</li>
                <li>Outside support services and supplies</li>
                <li>Dealing with nonconformances, corrective actions, and complaints</li>
              </ul>
            </div>
          </div>
          <p class="f16">

          </p>

          <p class="f16">
            In response to this assessment report, the laboratory must submit a response to each deficiency in
            the ORELAP Data Input and Edit (ODIE) database. Responses can be entered in ODIE at
            https://orelap.state.or.us/orelap. Login using your ODIE credentials and navigate to the inspection
            report. Instructions on how to respond to the findings in ODIE can be found on the ORELAP webpage.
            If you require assistance, please contact your assessors.
          </p>

          <p class="f16">
            In the laboratory's assessment response, you must:
          </p>

          <p class="f16">
            1. Respond to each deficiency cited with the following information:
          </p>

          <ul class="f16" style="list-style-type: disc;">
            <li>A summary of the investigation to determine the root cause(s) of the problem.</li>

            <li>
              A detailed explanation of the corrective action that the laboratory has either implemented or
              plans to implement. If the corrective action will take time to complete, the laboratory must
              provide a reasonable completion date. ORELAP may request a copy of the corrective action at the
              end of the completion date.
            </li>

            <li>
              Evidence of the corrective action, whenever possible, using the Upload feature. For example,
              submit a copy of document revisions or submit a copy of the log or bench sheet where the process
              was documented. Please limit individual document sizes to less than 20MB. In each response,
              include a reference to any uploaded attachments.
            </li>
          </ul>

          <p class="f16">
            2. Meet all deadlines.
          </p>

          <p class="f16">
            3. Do not click the Submit Response button until you have responded to all deficiencies. The
            Submit Response button will lock your CAP and submit it to ORELAP. You can click the Save button
            to save your progress and return later.
          </p>

          <p class="f16">
            The ORELAP assessment team will review the laboratory's response and determine whether it
            adequately addresses cited deficiencies. <b>
              The laboratory's response must be submitted to ORELAP
              within 30 calendar days from the receipt of the assessment report.
            </b> Failure to respond in this
            time frame may result in denial or revocation of accreditation, in part or total.
          </p>

          <p class="f16">
            List of Acronyms and Definitions which may be used in this report:
          </p>
          <div class="row">
            <div class="col-sm-12" style="font-family: 'DejaVu Sans', Arial, sans-serif;">
              <ul class="f16" style="list-style-type: disc;">
                <li><strong>&#176;C</strong> - Degrees Celsius</li>
                <li><strong>AA</strong> - Atomic Absorption</li>
                <li><strong>AB</strong> - Accreditation Body</li>
                <li><strong>ACM</strong> - Asbestos-containing Material</li>
                <li><strong>ACS</strong> - American Chemical Society</li>
                <li><strong>AF</strong> - Atomic Fluorescence</li>
                <li><strong>ASTM</strong> - American Society for Testing and Materials</li>
                <li><strong>BOD</strong> - Biochemical Oxygen Demand</li>
                <li><strong>BS</strong> - Blank Spike</li>
                <li><strong>BSD</strong> - Blank Spike Duplicate</li>
                <li><strong>C</strong> - Celsius</li>
                <li><strong>CAA</strong> - Clean Air Act</li>
                <li><strong>CAP</strong> - Corrective Action Plan</li>
                <li><strong>CBI</strong> - Confidential Business Information</li>
                <li><strong>CBOD</strong> - Carbonaceous Biological Oxygen Demand</li>
                <li><strong>CCB</strong> - Continuing Calibration Blank</li>
                <li><strong>CCV</strong> - Continuing Calibration Verification</li>
                <li><strong>CFR</strong> - United States Code of Federal Regulations</li>
                <li><strong>CFU</strong> - Colony-Forming Unit</li>
                <li><strong>COA</strong> - Certificate of Analysis</li>
                <li><strong>COC</strong> - Chain of Custody</li>
                <li><strong>COD</strong> - Chemical Oxygen Demand</li>
                <li><strong>CRM</strong> - Certified Reference Material</li>
                <li><strong>CV</strong> - Coefficient of Variation</li>
                <li><strong>CWA</strong> - Clean Water Act</li>
                <li><strong>DEQ</strong> - Department of Environmental Quality</li>
                <li><strong>DI</strong> - De-ionized</li>
                <li><strong>DL</strong> - Detection Limit</li>
                <li><strong>DRM-QA</strong> - Discharge Monitoring Report-Quality Assurance</li>
                <li><strong>DO</strong> - Dissolved Oxygen</li>
                <li><strong>DOC</strong> - Demonstration of Capability</li>
                <li><strong>DW</strong> - Drinking Water</li>
                <li><strong>DWS</strong> - Oregon Drinking Water Services program</li>
                <li><strong>EPA</strong> - United States Environmental Protection Agency</li>
                <li><strong>FOA</strong> - Field of Accreditation</li>
                <li><strong>FoPT</strong> - Fields of Proficiency Testing</li>
                <li><strong>GC</strong> - Gas Chromatography</li>
                <li><strong>GC-ECD</strong> - Gas Chromatography-Electron Capture Detector</li>
                <li><strong>GC-FID</strong> - Gas Chromatography-Flame Ionization Detector</li>
                <li><strong>GC-MS</strong> - Gas Chromatography-Mass Spectrometry</li>
                <li><strong>GC-MS/MS</strong> - Gas Chromatography-Mass Spectrometry-Mass Spectrometry</li>
                <li><strong>GC-NPD</strong> - Gas Chromatography-Nitrogen Phosphorus Detector</li>
                <li><strong>GC-PID</strong> - Gas Chromatography-Photoionization Detector</li>
                <li><strong>HPLC</strong> - High-Performance Liquid Chromatography</li>
                <li><strong>HPLC-FL</strong> - High-Performance Liquid Chromatography-Fluorescence Detection</li>
                <li><strong>HPLC-MS</strong> - High-Performance Liquid Chromatography-Mass Spectrometry</li>
                <li><strong>HPLC-MS/MS</strong> - High-Performance Liquid Chromatography-Mass Spectrometry-Mass
                  Spectrometry</li>
                <li><strong>HPLC-UV-VIS</strong> - High-Performance Liquid Chromatography-Ultraviolet-Visual
                  Spectroscopy</li>
                <li><strong>HRMS</strong> - High Resolution Mass Spectrometry</li>
                <li><strong>IC</strong> - Ion Chromatography</li>
                <li><strong>ICB</strong> - Initial Calibration Blank</li>
                <li><strong>ICP-AES</strong> - Inductively Coupled Plasma-Atomic Emission Spectroscopy</li>
                <li><strong>ICP-MS</strong> - Inductively Coupled Plasma-Atomic Mass Spectroscopy</li>
                <li><strong>ICV</strong> - Initial Calibration Verification</li>
                <li><strong>ID</strong> - Identification</li>
                <li><strong>iDOC</strong> - Initial Demonstration of Capability</li>
                <li><strong>IR</strong> - Infrared</li>
                <li><strong>ISE</strong> - Ion-Selective Electrode</li>
                <li><strong>IT</strong> - Information Technology</li>
                <li><strong>Kg</strong> - Kilogram</li>
                <li><strong>L</strong> - Liter</li>
                <li><strong>LC</strong> - Liquid Chromatography</li>
                <li><strong>LCS</strong> - Laboratory Control Sample</li>
                <li><strong>LCSD</strong> - Laboratory Control Sample Duplicate</li>
                <li><strong>LFM</strong> - Laboratory Fortified Matrix</li>
                <li><strong>LFMD</strong> - Laboratory Fortified Matrix Duplicate</li>
                <li><strong>LIMS</strong> - Laboratory Information Management System</li>
                <li><strong>LOD</strong> - Limit of Detection</li>
                <li><strong>LOEC</strong> - Lowest Observed Effect Concentration</li>
                <li><strong>LOQ</strong> - Limit of Quantitation</li>
                <li><strong>MB</strong> - Method Blank</li>
                <li><strong>MCL</strong> - Maximum Contaminant Level</li>
                <li><strong>MDL</strong> - Method Detection Limit</li>
                <li><strong>MF</strong> - Membrane Filtration</li>
                <li><strong>MFL</strong> - Million Fibers per Liter</li>
                <li><strong>mg</strong> - Milligram</li>
                <li><strong>MHW</strong> - Moderately Hard Water</li>
                <li><strong>MPN</strong> - Most Probable Number</li>
                <li><strong>MS</strong> - Matrix Spike</li>
                <li><strong>MSD</strong> - Matrix Spike Duplicate</li>
                <li><strong>MTF</strong> - Multiple Tube Fermentation</li>
                <li><strong>NELAC</strong> - National Environmental Laboratory Accreditation Conference</li>
                <li><strong>NELAP</strong> - National Environmental Laboratory Accreditation Program</li>
                <li><strong>ng</strong> - Nanogram</li>
                <li><strong>NIST</strong> - National Institute of Standards and Technology</li>
                <li><strong>Non-ACM</strong> - Non-Asbestos-containing Material</li>
                <li><strong>NOEC</strong> - No Observed Effect Concentration</li>
                <li><strong>NP</strong> - Non-potable</li>
                <li><strong>NPDES</strong> - National Pollutant Discharge Elimination System</li>
                <li><strong>OAR</strong> - Oregon Administrative Rules</li>
                <li><strong>ODA</strong> - Oregon Department of Agriculture</li>
                <li><strong>ODIE</strong> - ORELAP Data Input and Edit</li>
                <li><strong>oDOC</strong> - Ongoing Demonstration of Capability</li>
                <li><strong>OHA</strong> - Oregon Health Authority</li>
                <li><strong>ORELAP</strong> - Oregon Environmental Laboratory Accreditation Program</li>
                <li><strong>ORS</strong> - Oregon Revised Statutes</li>
                <li><strong>OSA</strong> - On-site Assessment</li>
                <li><strong>PCBs</strong> - Polychlorinated Biphenyls</li>
                <li><strong>PCM</strong> - Phase Contrast Microscopy</li>
                <li><strong>PCR</strong> - Polymerase Chain Reaction</li>
                <li><strong>PFAS</strong> - Per- and Polyfluoroalkyl Substances</li>
                <li><strong>PHD</strong> - Public Health Division</li>
                <li><strong>PLM</strong> - Polarized Light Microscopy</li>
                <li><strong>PMSD</strong> - Percent Minimum Significant Difference</li>
                <li><strong>ppb</strong> - Parts per Billion</li>
                <li><strong>ppm</strong> - Parts per Million</li>
                <li><strong>ppt</strong> - Parts per Trillion</li>
                <li><strong>PT</strong> - Proficiency Test</li>
                <li><strong>PTRL</strong> - Proficiency Testing Reporting Limit</li>
                <li><strong>QA</strong> - Quality Assurance</li>
                <li><strong>QC</strong> - Quality Control</li>
                <li><strong>RCRA</strong> - Resource Conservation and Recovery Act</li>
                <li><strong>RI</strong> - Refractive Index</li>
                <li><strong>RL</strong> - Reporting Limit</li>
                <li><strong>RPD</strong> - Relative Percent Difference</li>
                <li><strong>RSD</strong> - Relative Standard Deviation</li>
                <li><strong>SDWA</strong> - Safe Drinking Water Act</li>
                <li><strong>SIE</strong> - Selective Ion Electrode</li>
                <li><strong>SIM</strong> - Selected Ion Monitoring</li>
                <li><strong>SM</strong> - Standard Methods</li>
                <li><strong>SVOC</strong> - Semi-Volatile Organic Compounds</li>
                <li><strong>SOP</strong> - Standard Operating Procedure</li>
                <li><strong>SRT</strong> - Standard Reference Toxicant</li>
                <li><strong>SW</strong> - Source Water</li>
                <li><strong>TAC</strong> - Test Acceptability Criteria</li>
                <li><strong>TCLP</strong> - Toxicity Characteristic Leaching Procedure</li>
                <li><strong>TDS</strong> - Total Dissolved Solids</li>
                <li><strong>TEM</strong> - Transmission Electron Microscopy</li>
                <li><strong>TIE</strong> - Toxicity Identification Evaluation</li>
                <li><strong>TNI</strong> - The NELAC Institute</li>
                <li><strong>TOC</strong> - Total Organic Carbon</li>
                <li><strong>TRE</strong> - Toxicity Reduction Evaluation</li>
                <li><strong>TS</strong> - Total Solids</li>
                <li><strong>TSS</strong> - Total Suspended Solids</li>
                <li><strong>TVS</strong> - Total Volatile Solids</li>
                <li><strong>UV</strong> - Ultraviolet</li>
                <li><strong>UV-Vis</strong> - Ultraviolet-Visual Spectroscopy</li>
                <li><strong>VOC</strong> - Volatile Organic Compounds</li>
                <li><strong>WET</strong> - Whole Effluent Toxicity</li>
                <li><strong>µg</strong> - Microgram</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row page-break-before"></div>
        <div class="row">
          <div class="col-sm-12" style="border-bottom: 1px; border-bottom:solid">
            <span class="f18"><strong>Summary</strong></span>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-sm-12 f16">
            <div style="white-space: pre-wrap; word-wrap: break-word;">
              <span class="f16">{{inspectionData.summary | sanitizePdf}}</span>
            </div>
          </div>
        </div>
        <br/>
        <div class="row page-break-before"></div>
        <ng-container *ngFor="let caType of groupedCorrectiveActions">
          <div class="row page-break">
            <div class="col-sm-12" style="border-bottom: 1px; border-bottom:solid">
              <br/>
              <span class="f16"><strong>{{caType.header | sanitizePdf}}</strong></span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <ng-container *ngFor="let techGroup of caType.technologies">
                <div class="row" style="margin-top: 15pt">
                  <div class="col-sm-12">
                    <span class="f16"><strong>{{techGroup.tech | sanitizePdf}}</strong></span>
                  </div>
                </div>

                <ng-container *ngFor="let action of techGroup.actions">
                  <div class="row" style="margin-top: 10pt">
                    <div class="col-sm-12" style="border-top: 1px; border-top:solid">
                      <span class="f16"><strong><i>{{action.questionReferrence | sanitizePdf}}</i></strong></span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt">
                    <div class="col-sm-12">
                      <span class="f16"><i>{{action.question | sanitizePdf}}</i></span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt">
                    <div class="col-sm-12">
                      <span class="unstyled text-primary" style="font-size:x-large; white-space: pre-wrap; word-wrap: break-word; display: block;">
                        {{action.findings | sanitizePdf}}
                      </span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt" *ngIf="action.caResponseFirst">
                    <div class="col-sm-12">
                      <span class="unstyled" style="font-size:x-large; white-space: pre-wrap; word-wrap: break-word; display: block;">
                        {{action.caResponseFirst | sanitizePdf}}
                      </span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt" *ngIf="action.inspectorResponseFirst">
                    <div class="col-sm-12">
                      <span class="unstyled text-primary" style="font-size:x-large; white-space: pre-wrap; word-wrap: break-word; display: block;">{{action.inspectorResponseFirst | sanitizePdf}}</span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt" *ngIf="action.caResponseSecond">
                    <div class="col-sm-12">
                      <span class="unstyled" style="font-size:x-large; white-space: pre-wrap; word-wrap: break-word; display: block;">{{action.caResponseSecond | sanitizePdf}}</span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 5pt" *ngIf="action.inspectorResponseSecond">
                    <div class="col-sm-12">
                      <span class="unstyled text-primary" style="font-size:x-large; white-space: pre-wrap; word-wrap: break-word; display: block;">{{action.inspectorResponseSecond | sanitizePdf}}</span>
                    </div>
                  </div>
                </ng-container>

              </ng-container>
            </div>
          </div>

        </ng-container>

      </div>
    </kendo-pdf-export>
  </mat-card-content>
</mat-card>

